import { SVGProps, Ref, forwardRef } from 'react';

export const PopcornFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M13.982 23.942A33 33 0 0 1 12 24q-1.079-.002-1.985-.059L9.12 8.73c.952.111 1.913.171 2.88.171s1.927-.06 2.878-.17z"
            fill="currentColor"
        />
        <path
            d="M1.001 6.335a25 25 0 0 0 6.3 2.117l.901 15.315C4.398 23.243 3.594 22.014 3.585 22z"
            fill="currentColor"
        />
        <path d="M20.415 22c-.008.012-.81 1.242-4.62 1.767l.902-15.315A25 25 0 0 0 23 6.335z" fill="currentColor" />
        <path
            d="M12 0a5.14 5.14 0 0 1 3.41 1.282A5.2 5.2 0 0 1 17.1 1a5.11 5.11 0 0 1 4.59 2.817c.436.239.76.466.996.657A23.1 23.1 0 0 1 12 7.1c-3.757 0-7.418-.919-10.687-2.625.235-.19.56-.419.998-.658A5.11 5.11 0 0 1 6.9 1c.591 0 1.16.1 1.689.282A5.14 5.14 0 0 1 12 0"
            fill="currentColor"
        />
    </svg>
));
PopcornFilledSize24Glyph.displayName = 'PopcornFilledSize24Glyph';
